import { Map } from 'immutable';
import is from 'is_js';
import Note from './model';

import {
  FETCH_SINGLE_STUDENT_NOTE_SUCCESS,
  FETCH_STUDENT_NOTES_SUCCESS,
} from './actions';

export default function notes(state = new Map(), action) {
  let newState = state;
  let noteModel;
  switch (action.type) {
    case FETCH_SINGLE_STUDENT_NOTE_SUCCESS:
      noteModel = Note.create(action.payload);
      newState = newState.set(noteModel.id, noteModel);
      return newState;
    case FETCH_STUDENT_NOTES_SUCCESS: {
      if (is.array(action.payload)) {
        action.payload.forEach((note) => {
          noteModel = Note.create(note);
          newState = newState.set(noteModel.id, noteModel);
        });
      }
      return newState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./containers/Student/Note/reducer.js